var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-report-container"},[_c('ErrorReportForm',{staticClass:"foo",attrs:{"context":_vm.context}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }